import React from "react";
import RoutesSystem from "./routing/routing";

function App() {
  return <RoutesSystem />;
}

export default App;
